var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPageDividerArrowClose = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "44px",
  height: "44px",
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "ic_page_divider_arrow_close") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 16,
  cy: 16,
  r: 16
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_page_divider_arrow_close",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-20",
  transform: "translate(6.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval-8"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#D2DAE2",
  strokeWidth: 2,
  strokeLinejoin: "square",
  fill: "#ECF2F6",
  fillRule: "evenodd",
  cx: 16,
  cy: 16,
  r: 15
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#ECF2F6",
  strokeWidth: 6,
  cx: 16,
  cy: 16,
  r: 19
}))), /*#__PURE__*/React.createElement("g", {
  id: "baseline-keyboard_arrow_up-24px",
  transform: "translate(10.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  fill: "#8DA1B5",
  fillRule: "nonzero",
  transform: "translate(12.000000, 11.705000) scale(-1, -1) translate(-12.000000, -11.705000) ",
  points: "7.41 15.41 12 10.83 16.59 15.41 18 14 12 8 6 14"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  points: "0 0 24 0 24 24 0 24"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPageDividerArrowClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_page_divider_arrow_close.0dd8cc6f9e63d4412cde13a5a48ce7b8.svg";